import queryString from 'query-string';

export const HOST_MAP = {
	dev: 'https://justsleepbs.25demo.com',
	develop: 'https://justsleepbs.25demo.com',
	production: 'https://bs.justsleephotels.com',
};

const SELF_HOST_MAP = {
	dev: 'http://localhost:3000',
	develop: 'https://justsleep.25demo.com',
	production: 'https://www.justsleephotels.com',
};

export const API_ENDPOINT = HOST_MAP[process.env.NODE_ENV];
export const SELF_HOST_ENDPOINT = SELF_HOST_MAP[process.env.NODE_ENV];

export const wrapFetch = async (url, options = { headers: {} }, params = {}) => {
	const paramsString = queryString.stringify(params, { arrayFormat: 'bracket' });

	const URL =
		paramsString !== '' ? `${API_ENDPOINT}/${url}?${paramsString}` : `${API_ENDPOINT}/${url}`;

	const headers = new Headers({
		'Content-Type': 'application/json',
		Accept: 'application/json',
		...options.headers,
	});

	const result = await fetch(URL, { ...options, headers });

	return result.json();
};

export const wrapFetchFormData = async (url, options, params = {}) => {
	const paramsString = queryString.stringify(params);

	const URL =
		paramsString !== '' ? `${API_ENDPOINT}/${url}?${paramsString}` : `${API_ENDPOINT}/${url}`;

	const result = await fetch(URL, options);

	return result.json();
};



// WEBPACK FOOTER //
// ./src/actions/endpoint.js